import type { GetDesktopContactNumbers, GetMobileContactNumber } from './types';

export const getDesktopContactNumbers: GetDesktopContactNumbers = (
  hotlines: string[],
  waNumber: string | null,
) => {
  if (!waNumber) {
    return {
      hotlines,
      waNumber,
    };
  }

  const mergedHotlines = Array.from(
    new Set([...hotlines, waNumber].filter(h => h.trim() !== '')),
  );

  return {
    hotlines: mergedHotlines,
    waNumber,
  };
};

export const getMobileContactNumber: GetMobileContactNumber = (
  hotlines: string[],
  waNumber: string | null,
) => {
  if (!waNumber) {
    return {
      contactNumber: hotlines[0],
    };
  }

  return {
    contactNumber: waNumber,
  };
};
